import { render, staticRenderFns } from "./plans.component.vue?vue&type=template&id=baa810d2&scoped=true"
import script from "./plans.component.vue?vue&type=script&lang=js"
export * from "./plans.component.vue?vue&type=script&lang=js"
import style0 from "./plans.component.vue?vue&type=style&index=0&id=baa810d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baa810d2",
  null
  
)

export default component.exports